import { FC, useEffect, useState } from 'react';
import { AvsError } from '../../types';
import { getAvsInfo } from './avs-health';

interface AvsUnresponsiveProps {
  error: AvsError;
  onlyShowContent?: boolean;
}

const isHTML = (str: string | undefined): boolean => {
  const htmlRegex = /<[a-z][\s\S]*>/i;
  return !!str && htmlRegex.test(str);
};

const MORE_INFO = 'More Info';
const LESS_INFO = 'Less Info';

export const AvsUnresponsive: FC<AvsUnresponsiveProps> = ({
  error,
  onlyShowContent = false
}: AvsUnresponsiveProps) => {
  const [htmlError, setHtmlError] = useState<string | null>(null);
  const [jsonContent, setJsonContent] = useState<string | null>(null);
  const [buttonText, setButtonText] = useState<string>(MORE_INFO);

  useEffect(() => {
    const getAvsData = async () => {
      try {
        const avsInfo = await getAvsInfo();
        const errorCopy = { ...error };
        if (isHTML(error.error)) {
          setHtmlError(error.error || '');
          delete errorCopy.error;
        }
        const json = { ...errorCopy, ...avsInfo };
        setJsonContent(JSON.stringify(json, null, 2));
      } catch (error) {
        console.log('error', error);
      }
    };
    getAvsData();
  }, [
    error,
    setHtmlError,
    setJsonContent
  ]);

  const handleToggle = () => {
    if (buttonText === MORE_INFO) {
      setButtonText(LESS_INFO);
    } else {
      setButtonText(MORE_INFO);
    }
  };

  const content = (
    <span>
      {htmlError && <div dangerouslySetInnerHTML={{ __html: htmlError || '' }} />}
      <pre style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
        {jsonContent && jsonContent}
      </pre>
    </span>
  );

  return (onlyShowContent) ? content : (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="alert alert-warning" role="alert">
            <p className="text-center">
              <i className="fe icon-alert-triangle" /> {window.l.popup.avs_error}
              {'  '}
              <a
                className="btn-link btn-info"
                data-toggle="collapse"
                data-target="#more-info-page"
                onClick={handleToggle}>{ buttonText }</a>
            </p>
          </div>
        </div>
      </div>
      <div id="more-info-page" className="collapse">
        <div className="alert alert-warning" role="alert">
          {content}
        </div>
      </div>
    </>
  );
};
